export default "__VITE_ASSET__BGTw0oSs__"